import { AuthServer } from './../../services/auth-server.service';
import { PositionDayWksActionsComponent } from './position-day-wks-actions/position-day-wks-actions.component';
import { Constants } from '@utils/constants';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { AbstractItem } from '@business/base/abstract-item';
import { MatDialog } from '@angular/material/dialog';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { AbstractItemService } from '@business/base/abstract-item.service';
import { ActivatedRoute } from '@angular/router';
import { GridApi, GridOptions } from '../../../../node_modules/ag-grid';
import { ConfigService } from '@services/webFeeder/config.service';
import { Subscription } from '../../../../node_modules/rxjs';
import { PositionService } from '@services/webFeeder/sckt-position.service';
import { AppUtils } from '@utils/app.utils';
import { DailyOrderService } from '@services/webFeeder/sckt-daily-order.service';
import * as moment from 'moment';
import { NotificationsService } from 'angular2-notifications';
import { EletronicSignatureModalComponent } from '@component/eletronic-signature-modal/eletronic-signature-modal.component';
import { NormalModalComponent } from '@component/normal-modal/normal-modal.component';
import { MarketEnum } from '@model/enum/market.enum';
import { MarketTypeEnum } from '@model/enum/market-type.enum';

@Component({
  selector: Constants.WINDOW_NAME_POSITION_DAY,
  templateUrl: './position-day-wks.component.html'
})
export class PositionDayWksComponent extends AbstractItem implements OnInit, OnDestroy {
  @Input() override data: any;
  private gridApiPosition: GridApi;
  private subscriptions: Array<Subscription> = [];
  private auxSubscriptions: Array<Subscription> = [];
  private eletronicSignature = this.configService.getEletronicSignatureType();
  title = Constants.TITLE_CARD_POSITION_DAY;
  newWindow = false;
  windowActive: any;
  account: string;
  gridOptionsPosition: GridOptions;
  msgOfflineNegotiation = Constants.MSG_OFFLINE_NEGOTIATION_01;
  defaultColDef;
  showExpandCard = this.configService.getShowExpandCard(Constants.WINDOW_NAME_POSITION_DAY);
  rowDataPosition = [];
  strategiesList = [];
  columnDefsPosition = [
    { headerName: '', field: 'actions', width: 20, minWidth: 20, cellRendererFramework: PositionDayWksActionsComponent, cellClass: 'btn-col', showInSummaryView: true },
    { headerName: 'Ativo', field: 'quote', width: 100, minWidth: 80, maxWidth: 100, showInSummaryView: true },
    { headerName: 'C. Exec. Dia', field: 'executedBuy', width: 90, minWidth: 70, cellRenderer: this.renderToNumber.bind(this), cellClass: 'txt-right', headerClass: 'txt-right', },
    { headerName: 'V. Exec. Dia', field: 'executedSell', width: 90, minWidth: 70, cellRenderer: this.renderToNumber.bind(this), cellClass: 'txt-right', headerClass: 'txt-right', },
    { headerName: 'NET Dia', field: 'netDay', width: 70, minWidth: 70, cellRenderer: this.renderNet.bind(this), cellClass: 'txt-right', headerClass: 'txt-right', showInSummaryView: true },
    { headerName: 'Pr. Med. Aberto', field: 'averagePricePos', width: 110, minWidth: 70, cellClass: 'txt-right', headerClass: 'txt-right', showInSummaryView: true },
    { headerName: 'L/P Aberto', field: 'openProfitLoss', width: 90, minWidth: 70, cellClass: 'txt-right', headerClass: 'txt-right', cellRenderer: this.renderOpenProfit.bind(this), showInSummaryView: true },
    { headerName: 'L/P Fechado', field: 'closedProfitLoss', width: 90, minWidth: 70, cellClass: 'txt-right', headerClass: 'txt-right', cellRenderer: this.renderClosedProfit.bind(this), showInSummaryView: true },
    { headerName: 'L/P Total', field: 'lastTrade', cellRenderer: this.renderTotal.bind(this), width: 90, minWidth: 70, cellClass: 'txt-right', headerClass: 'txt-right', showInSummaryView: true },
    { headerName: 'Mercado', field: 'market', width: 90, minWidth: 70, }
  ];
  activeColumnDefsPosition = [];
  views = [
    { type: 'summary', title: 'Resumida' },
    { type: 'detailed', title: 'Detalhada' }
  ];
  activeView: { type: string, title: string };
  loading: boolean;
  financialInfo = this.newFinancialInfo();
  positionDayHelpText = 'Nesta tela são apresentadas apenas posições do dia, não sendo consideradas posições iniciais (posição de custódia).';
  removeFromWksTooltip = Constants.TOOLTIP_REMOVE_WKS_TOOL;

  // TODO: Desabilitado opção de selecionar e limpar posições em lote
  // lengthChecked: any;
  // checkedItems: boolean;
  // checkIndeterminate: boolean;
  // rowSelection = 'multiple';

  constructor(
    _dialog: MatDialog,
    _workspaceService: WorkspaceNewService,
    _itemService: AbstractItemService,
    private route: ActivatedRoute,
    private configService: ConfigService,
    private positionService: PositionService,
    private authServer: AuthServer,
    private notificationService: NotificationsService,
    private dailyOrderService: DailyOrderService,
  ) {
    super(_workspaceService, _dialog, _itemService);
    this.workspaceService = _workspaceService;
    this.dialog = _dialog;
  }

  ngOnInit() {
    this.loading = true;
    this.getStrategies();
    this.route.queryParams.subscribe(params => {
      if (params['account']) {
        this.account = params['account'];
        this.newWindow = true;
      }
    });
    if (this.newWindow) {
      setTimeout(() => {
        this.getStrategies();
      }, 50);
    } else {
      this.auxSubscriptions.push(
        this.configService.authHbLogged$.subscribe(loggedNegotiation => {
          if (loggedNegotiation) {
            this.account = this.configService.getBrokerAccountSelected();
          } else {
            if (this.account) {
              this.positionService.unsubscribePosition(this.account, Constants.WINDOW_NAME_POSITION_DAY);
              this.account = null;
              this.subscriptions.forEach(subscription => subscription.unsubscribe());
            }
          }
        }));
      this.auxSubscriptions.push(
        this.configService.changeAccountBillet$.subscribe(account => {
          if (account && account.toString() != this.account) {
            this.positionService.unsubscribePosition(this.account, Constants.WINDOW_NAME_POSITION_DAY, true);
            this.subscriptions.forEach(subscription => subscription.unsubscribe());
            this.account = account;
            this.gridApiPosition.setRowData([]);
            this.financialInfo = this.newFinancialInfo();
            this.subscribePositions();
          }
        }));
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.auxSubscriptions.forEach(subscription => subscription.unsubscribe());
    this.positionService.unsubscribePosition(this.account, Constants.WINDOW_NAME_POSITION_DAY);
    this.closeSheet();
  }

  getStrategies() {
    this.authServer.iNegotiation.getStrategies()
      .subscribe(res => {
        if (res && res.length > 0) {
          this.strategiesList = res;
          res.forEach(element => {
            if (element && element.orderStrategy === 'POSITION' && !this.columnDefsPosition.find(x => x.field === 'netPosition')) {
              this.columnDefsPosition.splice(5, 0, {
                headerName: 'NET Position',
                field: 'netPosition',
                width: 100,
                minWidth: 80,
                cellRenderer: this.renderNet.bind(this),
                cellClass: 'txt-right',
                headerClass: 'txt-right',
              });
            } else if (element && element.orderStrategy === 'DAYTRADE' && !this.columnDefsPosition.find(x => x.field === 'netDaytrade')) {
              this.columnDefsPosition.splice(5, 0, {
                headerName: 'NET DayTrade',
                field: 'netDaytrade',
                width: 100,
                minWidth: 80,
                cellRenderer: this.renderNet.bind(this),
                cellClass: 'txt-right',
                headerClass: 'txt-right',
              });
            }
          });
        }
        this.setGridOptions();
      }, () => {
        this.setGridOptions();
      });
  }

  newFinancialInfo() {
    return {
      lucroPrejuizoCloseFormated: null,
      lucroPrejuizoClose: null,
      lucroPrejuizoOpenFormated: null,
      lucroPrejuizoOpen: null,
      lucroPrejuizoTotalFormated: null,
      lucroPrejuizoTotal: null
    };
  }

  isRowSelectable = function (rowNode) {
    return rowNode.data ? Number(rowNode.data.netDay) != 0 : false;
  };

  setGridOptions() {
    this.setGridView(this.views[0]);
    this.gridOptionsPosition = <GridOptions>{
      headerHeight: 32,
      rowHeight: 25,
      enableColResize: true,
      defaultColDef: {
        sortable: true,
        // TODO: Desabilitado opção de selecionar e limpar posições em lote
        // headerCheckboxSelection: this.isFirstColumn,
        // headerCheckboxSelectionFilteredOnly: true,
        // checkboxSelection: this.isFirstColumn,
      },
      getRowNodeId: (data) => {
        return data.quote;
      },
      localeText: { noRowsToShow: Constants.MSG_NO_DATA_TO_SHOW },
      context: { componentParent: this, scope: this }
    };
    this.loading = false;
  }

  setGridView(view: { type: string, title: string }) {
    this.activeView = view;
    if (view.type === 'detailed') {
      this.activeColumnDefsPosition = this.columnDefsPosition;
    } else {
      this.activeColumnDefsPosition = this.columnDefsPosition.filter(col => col.showInSummaryView);
    }
  }

  hasMultipleStrategies() {
    let hasPosition;
    let hasDaytrade;
    if (this.strategiesList.length > 0) {
      hasPosition = this.strategiesList.find(position => position.orderStrategy === 'POSITION');
      hasDaytrade = this.strategiesList.find(position => position.orderStrategy === 'DAYTRADE');
    }
    return hasDaytrade && hasPosition;
  }

  // TODO: Desabilitado opção de selecionar e limpar posições em lote
  // isFirstColumn(params) {
  //   const displayedColumns = params.columnApi.getAllDisplayedColumns();
  //   const thisIsFirstColumn = displayedColumns[0] === params.column;
  //   return thisIsFirstColumn;
  // }

  renderTotal(param) {
    if (param) {
      const openProfit = param.data.marketCode == 'XBSP' ? AppUtils.convertBrCurrencyToNumber(param.data.openProfitLoss, ',') : AppUtils.convertBrCurrencyToNumber(param.data.openProfitLoss, '.') || 0;
      const closedProfit = param.data.marketCode == 'XBSP' ? AppUtils.convertBrCurrencyToNumber(param.data.closedProfitLoss, ',') : AppUtils.convertBrCurrencyToNumber(param.data.closedProfitLoss, '.') || 0;
      const total = openProfit + closedProfit;
      const cellClass = total > 0 ? 'positive-value' : total < 0 ? 'negative-value' : '';
      return '<span class="' + cellClass + '">' + AppUtils.convertNumberToCurrency(total) + "</span>"
    }
  }

  renderToNumber(param) {
    if (param && param.value) {
      return Number(param.value);
    } else {
      return '-';
    }
  }

  renderNet(param) {
    if (param && param.value) {
      const cellClass = Number(param.value) > 0 ? 'positive-value' : Number(param.value) < 0 ? 'negative-value' : '';
      return '<span class="' + cellClass + '">' + Number(param.value) + "</span>"
    } else {
      return '-';
    }
  }

  renderOpenProfit(param) {
    if (param && param.value) {
      const profitValue = AppUtils.convertBrCurrencyToNumber(param.data.openProfitLoss, '.') || 0;
      const cellClass = profitValue > 0 ? 'positive-value' : profitValue < 0 ? 'negative-value' : '';
      return '<span class="' + cellClass + '">' + AppUtils.convertNumberToCurrency(profitValue) + "</span>"
    } else {
      return '-';
    }
  }

  renderClosedProfit(param) {
    if (param && param.value) {
      const profitValue = AppUtils.convertBrCurrencyToNumber(param.data.closedProfitLoss, '.') || 0;
      const cellClass = profitValue > 0 ? 'positive-value' : profitValue < 0 ? 'negative-value' : '';
      return '<span class="' + cellClass + '">' + AppUtils.convertNumberToCurrency(profitValue) + "</span>"
    } else {
      return '-';
    }
  }

  canReset(position) {
    return Number(position.netDay) != 0;
  }

  // TODO: Desabilitado opção de selecionar e limpar posições em lote
  // changeCheck(event) {
  //   if (event.checked) {
  //     this.gridApiPosition.selectAllFiltered();
  //   } else {
  //     this.gridApiPosition.deselectAllFiltered();
  //   }
  // }

  // verifySelectedPositionsToReset() {
  //   const confirmDialog = this.dialog.open(ConfirmationModalComponent, {
  //     panelClass: Constants.NORMAL_MODAL,
  //   });
  //   confirmDialog.componentInstance.content = 'Deseja realmente zerar a posição dos ativos selecionados ?';
  //   confirmDialog.afterClosed().subscribe(result => {
  //     if (result) {
  //       const selectedPositions = this.gridApiPosition.getSelectedNodes();
  //       selectedPositions.forEach(node => this.resetPosition(node.data));
  //       this.gridApiPosition.deselectAllFiltered();
  //     }
  //   });
  // }

  verifyPositionToReset(position) {
    if (position) {
      const posTemp = position.netDay ? Number(position.netDay) : 0;
      position.marketCode = position.marketCode === MarketTypeEnum.BOVESPA ? MarketEnum.BOVESPA : MarketEnum.BMF;
      if (posTemp <= 0) {
        this.notificationService.warn('', Constants.ORDER_CLEAR_MSG013.replace('[QUOTE]', position.quote.toUpperCase()));
        return;
      }
      let modalOrders;
      const signature = this.configService.getHbSignature();
      if (this.eletronicSignature && this.eletronicSignature.isActive && !this.configService.isUserAssessorLogged()) {
        if (signature) {
          this.validSignaure(signature, 'clearPosition', position);
        } else {
          modalOrders = this.dialog.open(EletronicSignatureModalComponent, {
            panelClass: Constants.ELETRONIC_SIGNATURE_MODAL, width: '350px', disableClose: true
          });
        }
      } else {
        modalOrders = this.dialog.open(NormalModalComponent, {
          data: { title: Constants.ORDER_HISTORY_MSG011, body: Constants.ORDER_HISTORY_MSG012, isHistoryOrderWSO2: false },
          panelClass: 'mat-modal-normal',
        });
      }
      if (modalOrders) {
        modalOrders.afterClosed().subscribe(result => {
          if (result) {
            this.sendClearPosition(position.quote, position.marketCode);
          } else {
            if (this.configService.isLoginTypeWSO2() && !this.configService.isUserAssessorLogged()) {
              this.notificationService.info('', Constants.BILLET_ORDER_SEND_06);
            }
          }
        });
      }
    }
  }

  validSignaure(signature, action, position) {
    let paramsSignature;
    let clientId;
    if (this.eletronicSignature.type === Constants.ELETRONIC_SIGNATURE_TYPES.string) {
      clientId = Number(this.configService.getHbAccountId());
      paramsSignature = { user_client_id: clientId, signature: signature };
    } else {
      paramsSignature = signature;
    }
    this.authServer.iEletronicSignature.validateSignature(paramsSignature)
      .subscribe(res => {
        if ((this.eletronicSignature.type === Constants.ELETRONIC_SIGNATURE_TYPES.string && res && res._isScalar !== false && res.is_valid)
          || (this.eletronicSignature.type === Constants.ELETRONIC_SIGNATURE_TYPES.virtual_keyboard
            && res && res.IsResponseOk && res.SerializedObject && JSON.parse(res.SerializedObject).Autenticado)) {
          if (action === 'clearPosition') {
            this.sendClearPosition(position.quote, position.marketCode);
          }
        } else {
          this.notificationService.error('', Constants.BILLET_ORDER_SEND_07);
          this.configService.deleteHbSignature();
          return false;
        }
      });
  }

  sendClearPosition(symbol: string, market: MarketEnum) {
    this.authServer.iNegotiation.customLiquidationClient(symbol, market)
      .subscribe(res => {
        if (res && res.code === 0) {
          this.notificationService.info('', Constants.BILLET_ORDER_SEND_14);
        } else {
          this.notificationService.error('', Constants.BILLET_ORDER_SEND_09);
        }
      }, () => {
        this.notificationService.error('', Constants.BILLET_ORDER_SEND_09);
      });
  }

  onGridReady(params) {
    this.gridApiPosition = params.api;
    this.subscribePositions();
  }

  subscribePositions() {
    if (this.account) {
      this.subscriptions.push(this.positionService.subscribePosition(this.account, Constants.WINDOW_NAME_POSITION_DAY)
        .subscribe(data => {
          if (data) {
            Object.keys(data).forEach(element => {
              this.updatePositions(data[element]);
            });
          }
        }
        ));
      this.subscriptions.push(this.positionService.messagesPosition
        .subscribe(res => {
          this.updatePositions(res);
        })
      );
    }
  }

  updatePositions(response) {
    const dataLength = this.gridApiPosition.getDisplayedRowCount();
    const presenterPositions = [...response];
    if (dataLength === 0) {
      presenterPositions.forEach(position => {
        if (Number(position.executedBuy) != 0 || Number(position.executedSell) != 0) {
          this.gridApiPosition.updateRowData({ add: [position], addIndex: (this.gridApiPosition.getDisplayedRowCount()) });
        }
      });
    } else {
      presenterPositions.forEach(position => {
        const renderedNodes = this.gridApiPosition.getRenderedNodes();
        const positionToEdit = renderedNodes.findIndex(item => item.id == position['quote']);
        if (positionToEdit != undefined && positionToEdit != -1) {
          this.gridApiPosition.updateRowData({ update: [position] });
          this.gridApiPosition.refreshCells({ columns: ['actions'], force: true });
        } else {
          if (Number(position.executedBuy) != 0 || Number(position.executedSell) != 0) {
            this.gridApiPosition.updateRowData({ add: [position], addIndex: (this.gridApiPosition.getDisplayedRowCount()) });
          }
        }
      });
      this.updateFinancialPosition(this.gridApiPosition.getRenderedNodes());
    }
  }

  updateFinancialPosition(nodes) {
    if (nodes && nodes.length > 0) {
      let openProfit = 0;
      let closedProfit = 0;
      nodes.forEach(node => {
        if (node.data.marketCode == 'XBSP') {
          node.data.openProfitLoss ? openProfit += AppUtils.convertBrCurrencyToNumber(node.data.openProfitLoss, ',') : null;
          node.data.closedProfitLoss ? closedProfit += AppUtils.convertBrCurrencyToNumber(node.data.closedProfitLoss, ',') : null;
        } else {
          node.data.openProfitLoss ? openProfit += AppUtils.convertBrCurrencyToNumber(node.data.openProfitLoss, '.') : null;
          node.data.closedProfitLoss ? closedProfit += AppUtils.convertBrCurrencyToNumber(node.data.closedProfitLoss, '.') : null;
        }
      });

      this.financialInfo.lucroPrejuizoClose = Number(closedProfit) || 0;
      this.financialInfo.lucroPrejuizoCloseFormated = AppUtils.convertNumberToCurrency(Number(closedProfit)) || '-';
      this.financialInfo.lucroPrejuizoOpen = Number(openProfit) || 0;
      this.financialInfo.lucroPrejuizoOpenFormated = AppUtils.convertNumberToCurrency(Number(openProfit)) || '-';
      this.financialInfo.lucroPrejuizoTotal = Number(this.financialInfo.lucroPrejuizoOpen + this.financialInfo.lucroPrejuizoClose) || 0;
      this.financialInfo.lucroPrejuizoTotalFormated = AppUtils.convertNumberToCurrency(Number(this.financialInfo.lucroPrejuizoOpen
        + this.financialInfo.lucroPrejuizoClose)) || '-';
    }
  }

  // TODO: Desabilitado opção de selecionar e limpar posições em lote
  // onSelectionChanged(event) {
  //   const allNodes = this.gridApiPosition.getRenderedNodes();
  //   let length = 0;
  //   allNodes.forEach(node => {
  //     if (node.selectable) {
  //       length++;
  //     }
  //   })
  //   this.lengthChecked = event.api.getSelectedNodes().length;
  //   if (this.lengthChecked > 0) {
  //     if (this.lengthChecked === length) {
  //       this.checkedItems = true;
  //       setTimeout(() => {
  //         this.checkIndeterminate = false;
  //       }, 100);
  //     } else {
  //       this.checkIndeterminate = true;
  //       this.checkedItems = false;
  //     }
  //   } else {
  //     this.checkedItems = false;
  //     this.checkIndeterminate = false;
  //   }
  // }

  openNewWindow() {
    const options = 'width=600px, height=300px';
    const parameters = '?account=' + this.account;
    if (this.windowActive == null || this.windowActive.closed) {
      super.getNewWindow(Constants.WINDOW_NAME_POSITION_DAY, parameters, options, this.data.id)
        .subscribe(window => {
          this.windowActive = window;
        });
    } else {
      this.windowActive.focus();
    }
  }

  closeSheet() {
    if (this.windowActive != null) {
      this.windowActive.close();
    }
  }

}
